import { Navigate, useParams } from "react-router-dom";
import { ROUTES } from "@/routes";
import { isFirmTabKind } from "@/api/profiles/firmTabsService";
import { FirmTabForm } from "./FirmTabForm";

export function FirmTabDetail() {
  const { kind, id } = useParams<{ kind: string; id: string }>();
  if (!isFirmTabKind(kind) || !id) {
    return <Navigate to={ROUTES.profiles.firmTabs} replace />;
  }
  return <FirmTabForm kind={kind} mode="edit" id={id} />;
}

export default FirmTabDetail;
